export const STAFF_VIDEOS_KEY = ['staff', 'videos'];
export const STAFF_PLAYLISTS_KEY = ['staff', 'playlists'];
